import { MutationTree } from 'vuex';
import { ErrorDetail } from '../../types';
import { NodeIdpState, NodeIdp } from './types';
import * as types from './mutation-types';

// 接続テスト・更新・削除のエラーをクリアする
const resetChangesAllErrors = (state: NodeIdpState): void => {
    const updateState = state.update;
    updateState.error = false;
    updateState.errorTitle = undefined;
    updateState.errorDetails = undefined;

    const destroyState = state.destroy;
    destroyState.error = false;
    destroyState.errorTitle = undefined;
    destroyState.errorDetails = undefined;

    const connectionTestState = state.connectionTest;
    connectionTestState.error = false;
    connectionTestState.errorTitle = undefined;
    connectionTestState.errorDetails = undefined;

    const csvState = state.csv;
    csvState.error = false;
    csvState.errorCode = undefined;
    csvState.errorMsg = undefined;
};

export const mutations: MutationTree<NodeIdpState> = {
    // ノードIdP一覧系
    [types.INDEX_START](state) {
        const indexState = state.index;
        indexState.error = false;
        indexState.errorCode = undefined;
        indexState.errorMsg = undefined;
        indexState.isProcessing = true;
        indexState.isFetchSuccess = false;
    },

    [types.INDEX_SUCCESS](state, payload: { count: number; node_idps: Array<NodeIdp> }) {
        state.nodeIdpCount = payload.count;
        state.nodeIdps = payload.node_idps;

        const indexState = state.index;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = true;
    },

    [types.INDEX_FAILURE](state, payload: { code: string; message: string }) {
        const indexState = state.index;
        indexState.errorCode = payload.code;
        indexState.errorMsg = payload.message;
        indexState.error = true;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = false;
    },

    // ノードIdP作成系
    [types.NEW_NODE_IDP](state) {
        resetChangesAllErrors(state);
        const createState = state.create;
        createState.error = false;
        createState.errorTitle = undefined;
        createState.errorDetails = undefined;
        createState.isCreated = false;
    },

    [types.CREATE_START](state) {
        const createState = state.create;
        createState.error = false;
        createState.errorTitle = undefined;
        createState.errorDetails = undefined;
        createState.isProcessing = true;
    },

    [types.CREATE_SUCCESS](state) {
        const createState = state.create;
        createState.isProcessing = false;
        createState.isCreated = true;
    },

    [types.CREATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const createState = state.create;
        createState.errorTitle = payload.errorTitle;
        createState.errorDetails = payload.errorDetails;
        createState.error = true;
        createState.isProcessing = false;
    },

    // ノードIdP詳細情報参照系
    [types.SHOW_START](state) {
        resetChangesAllErrors(state);
        const showState = state.show;
        showState.error = false;
        showState.errorCode = undefined;
        showState.errorMsg = undefined;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;
    },

    [types.SHOW_SUCCESS](state, payload: { node_idp: NodeIdp }) {
        state.nodeIdpDetails.node_idp = payload.node_idp;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = true;
    },

    [types.SHOW_FAILURE](state, payload: { code: string; message: string }) {
        const showState = state.show;
        showState.errorCode = payload.code;
        showState.errorMsg = payload.message;
        showState.error = true;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    // ノードIdP更新系
    [types.UPDATE_START](state) {
        resetChangesAllErrors(state);
        const updateState = state.update;
        updateState.isProcessing = true;
    },

    [types.UPDATE_SUCCESS](state) {
        const updateState = state.update;
        updateState.isProcessing = false;
    },

    [types.UPDATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const updateState = state.update;
        updateState.errorTitle = payload.errorTitle;
        updateState.errorDetails = payload.errorDetails;
        updateState.error = true;
        updateState.isProcessing = false;
    },

    // 接続テスト系
    [types.CONNECTION_TEST_START](state) {
        resetChangesAllErrors(state);
        const connectionTestState = state.connectionTest;
        connectionTestState.isProcessing = true;
    },

    [types.CONNECTION_TEST_SUCCESS](state) {
        const connectionTestState = state.connectionTest;
        connectionTestState.isProcessing = false;
    },

    [types.CONNECTION_TEST_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const connectionTestState = state.connectionTest;
        connectionTestState.errorTitle = payload.errorTitle;
        connectionTestState.errorDetails = payload.errorDetails;
        connectionTestState.error = true;
        connectionTestState.isProcessing = false;
    },

    // ノードIdP削除系
    [types.DESTROY_START](state) {
        resetChangesAllErrors(state);
        const destroyState = state.destroy;
        destroyState.isProcessing = true;
    },

    [types.DESTROY_SUCCESS](state) {
        const destroyState = state.destroy;
        destroyState.isProcessing = false;
    },

    [types.DESTROY_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const destroyState = state.destroy;
        destroyState.errorTitle = payload.errorTitle;
        destroyState.errorDetails = payload.errorDetails;
        destroyState.error = true;
        destroyState.isProcessing = false;
    },

    // CSV出力系
    [types.CSV_OUTPUT_START](state) {
        resetChangesAllErrors(state);
        const csvState = state.csv;
        csvState.isProcessing = true;
    },

    [types.CSV_OUTPUT_SUCCESS](state) {
        const csvState = state.csv;
        csvState.isProcessing = false;
    },

    [types.CSV_OUTPUT_FAILURE](state, payload: { code: string; message: string }) {
        const csvState = state.csv;
        csvState.errorCode = payload.code;
        csvState.errorMsg = payload.message;
        csvState.error = true;
        csvState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const indexState = state.index;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = false;

        const createState = state.create;
        createState.isProcessing = false;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;

        const updateState = state.update;
        updateState.isProcessing = false;

        const connectionTestState = state.connectionTest;
        connectionTestState.isProcessing = false;

        const destroyState = state.destroy;
        destroyState.isProcessing = false;

        const csvState = state.csv;
        csvState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        resetChangesAllErrors(state);
        state.nodeIdps = undefined;
        state.nodeIdpCount = 0;
        state.nodeIdpDetails.node_idp = undefined;
    },
};
